module.exports = __webpack_public_path__ + "media/images/front/icons/profile_edit-51d7b27395ee0af0119eda8b2d87f86d.png";